import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import myAxios from '../../../../lib/axios';


const initialState = {
    data: [],
};

export const fetchEnquiry = createAsyncThunk(
    'masters/fetchEnquiry',
    async (query) => {
        try {
            const response = await myAxios.get(`/enquiries/all`);
          
            return { success: true, message: "Enquirys fetched successfully!", data: response?.data?.list };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);


export const deleteEnquiry = createAsyncThunk(
    'masters/deleteEnquiry',
    async (query) => {
        try {
            const response = await myAxios.delete(`/enquiries/delete?enquiry=${query.enquiryId}`);
            return { success: true, message: "Enquiry deleted successfully!", data: response?.data?.list };
        } catch (error) {
            if (error?.response?.data) {
                return { success: false, message: error?.response?.data?.message };
            } else {
                return { success: false, message: 'Sorry, something went wrong!' };
            }
        }
    },
);



const enquirySlice = createSlice({
    name: 'enquiry',
    initialState,
    reducers: {
        clearEnquiryData: state => {
            state.data = [];
        },
        setEnquiryData: (state, action) => {
            state.data = action.payload;
        },
       
    },
});

export const enquiryReducer = enquirySlice.reducer;
export const { clearEnquiryData, setEnquiryData } = enquirySlice.actions;

export const selectEnquiryData = (state) => state.enquiry.data;
